/**
 * Waits for an element to exist in the DOM
 * @param {string} selector - CSS selector for the element
 * @param {number} timeout - Maximum time to wait in milliseconds (default: 5000)
 * @param {number} checkInterval - How often to check in milliseconds (default: 100)
 * @return {Promise} - Resolves with the element or rejects if timeout is reached
 */
function waitForElement(selector, timeout = 5000, checkInterval = 100) {
  return new Promise((resolve, reject) => {
    const startTime = Date.now();
    
    const checkForElement = () => {
      const element = document.querySelector(selector);
      
      if (element) {
        // Element found, resolve the promise with the element
        resolve(element);
        return;
      }
      
      // Check if we've exceeded the timeout
      if (Date.now() - startTime >= timeout) {
        reject(new Error(`Element ${selector} not found within ${timeout}ms`));
        return;
      }
      
      // Try again after the check interval
      setTimeout(checkForElement, checkInterval);
    };
    
    // Start checking
    checkForElement();
  });
}

globalThis.closeQuickAddModal = () => {
  const $quickAddModal = document.querySelector('.quick-add-modal');
  $quickAddModal.classList.remove('open');
  document.documentElement.classList.remove('overflow-hidden');
};

if (document.body.dataset.template === 'product') {
  if (globalThis.localStorage.getItem('bis') === 'true') {
    globalThis.localStorage.removeItem('bis');

    waitForElement('.klaviyo-bis-trigger')
      .then(element => {
        setTimeout(() => {
          element.click();
        }, 1750);
      })
      .catch(error => {
        console.error(error.message);
      });
  }
}

if (document.body.dataset.template !== 'collection') {
  // Create quick add events for product cards
  const $productCards = document.querySelectorAll('.product-card-wrapper');
  
  $productCards.forEach($productCard => {
    if ($productCard.dataset.url) {
      const prod = {
        url: $productCard.dataset.url,
      };
  
      $productCard.querySelector('.quick-add-btn').addEventListener('click', () => {
        fetch(prod.url + '?view=quick-add')
          .then(res => res.text())
          .then(quickAddStr => {
            const $quickAddModal = document.querySelector('.quick-add-modal');
            $quickAddModal.querySelector('.quick-add-modal__inner').innerHTML = quickAddStr;
            const $slider = $quickAddModal.querySelector('.js-slider-collectionPage');
            new Swiper($slider, {
              slidesPerView: 1.7,
              spaceBetween: 8,
              loop: false,
              freeMode: {
                enabled: true,
                sticky: true,
                momentumRatio: 0.3
              },
            });
            $quickAddModal.classList.add('open');
            document.documentElement.classList.add('overflow-hidden');
          })
      });
    }
  });

  // Initialize Swiper for product cards
  new Swiper(".js-slider-collectionPage", {
    slidesPerView: "auto",
    loop: true,
    freeMode: {
      enabled: true,
      sticky: true,
      momentumRatio: 0.3
    },
    pagination: {
      el: '.swiper-pagination',
    },
    navigation: {
      nextEl: ".js-card-slider-arrow-next",
      prevEl: ".js-card-slider-arrow-prev",
    },
  });
}

function fetchCardSlideData(handle, isQuickAdd) {
  const selectors = {
    productCard: '.card-wrapper',
  };
  const cardStorageKey = isQuickAdd ? `quickAdd-${handle}` : handle;
  let sessionCardSlide = sessionStorage.getItem(cardStorageKey);

  if (sessionCardSlide) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(sessionCardSlide, 'text/html');
    sessionCardSlide = doc.body.firstChild;
  }

  if (sessionCardSlide) {
    console.log("%cFetched from session", "color:yellow");
    return new Promise((resolve) => {
      resolve(sessionCardSlide);
    });
  }

  console.log("%cFetched from URL", "color:green");
  return getDataFromShopifyUrl(handle);

  function getProductCardUrl(handle) {
    switch (true) {
      case isQuickAdd:
        return `/products/${handle}?view=quick-add`;
      default:
        return `/products/${handle}?view=klevu-template`;
    }
  }

  function getDataFromShopifyUrl(handle) {
    return new Promise((resolve, reject) => {
      fetch(getProductCardUrl(handle))
        .then(response => response.text())
        .then(data => {
          const parser = new DOMParser();
          const dom = parser.parseFromString(data, 'text/html');
          const card = dom.querySelector(selectors.productCard);

          if (!card) resolve(null);

          sessionStorage.setItem(cardStorageKey, card.outerHTML);
          resolve(card);
        })
        .catch((e) => {
          reject(e);
        });
    });
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};


Shopify.loadElements = function (data, selectors, parent = document) {
  Object.keys(selectors).forEach(key => {
    if (key[0] === '#') {
      data[key] = parent.getElementById(selectors[key].substring(1));
    }
    else if (key.slice(-1) === 's') {
      data[key] = parent.querySelectorAll(selectors[key]);
    }
    else {
      data[key] = parent.querySelector(selectors[key]);
    }
  });
};

Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.', ''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    this.querySelectorAll('[data-tabbed="true"]').forEach(tabGroup => tabGroup.addEventListener('keyup', this.horizontalTabOnKeyup.bind(this)));
    this.querySelectorAll('[aria-orientation="vertical"]').forEach(verticalTabGroup => verticalTabGroup.addEventListener('keyup', this.verticalTabOnKeyup.bind(this)));

  }
  verticalTabOnKeyup() {
    if (event.key == 'ArrowUp') {
      let previousButton = event.target.closest('li').previousElementSibling;
      previousButton.querySelector('summary').focus();
    }
    else if (event.key == 'ArrowDown') {
      let nextButton = event.target.closest('li').nextElementSibling;
      nextButton.querySelector('summary').focus();
    }
  }
  horizontalTabOnKeyup() {
    if (event.key == 'ArrowLeft') {
      let previousButton = event.target.closest('li').previousElementSibling;
      previousButton.querySelector('summary').focus();
    }
    else if (event.key == 'ArrowRight') {
      let nextButton = event.target.closest('li').nextElementSibling;
      nextButton.querySelector('summary').focus();
    }
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const currentId = detailsElement.dataset.toggleId;

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    }
    else if (currentId) {
      if (detailsElement.open) {
        event.preventDefault();
        summaryElement.open = true;
      }
      else {
        let parent = summaryElement.closest('ul');
        let siblings = parent.querySelectorAll(`details:not([data-toggle-id="${currentId}"]`);
        siblings.forEach(details => details.open = false);
        summaryElement.open = true;
      }

    }
    else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.classList.remove('menu-opening');
      this.closeAnimation(details);
    });

    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });

    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, summaryElement, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);

    if (event instanceof HTMLElement) {
      event.setAttribute('aria-expanded', false);
    }

    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.documentElement.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.documentElement.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));

    // Create an Intersection Observer
    const observer = new IntersectionObserver(this.handleIntersection.bind(this));
    observer.observe(this);
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
  
  handleIntersection(entries) {
    const entry = entries[0];
    if (entry.isIntersecting) {
      // Element is intersecting, play the video
      this.loadContent();
      this.playVideo();
    } else {
      // Element is not intersecting, pause the video
      this.pauseVideo();
    }
  }

  playVideo() {
    const deferredElement = this.querySelector('video, model-viewer, iframe');
    if (deferredElement && typeof deferredElement.play === 'function') {
      deferredElement.play().catch(error => {
        // Handle autoplay error, if necessary
        console.error('Autoplay error:', error);
      });
    }
  }

  pauseVideo() {
    const deferredElement = this.querySelector('video, model-viewer, iframe');
    if (deferredElement && typeof deferredElement.pause === 'function') {
      deferredElement.pause();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    if (!this.slider) {
      this.slider = this.querySelector('ul');
    }
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    if (this.sliderItems.length == 0) {
      this.sliderItems = this.querySelectorAll('li');
    }
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    if (this.enableSliderLooping) {
      this.prevButton.removeAttribute('disabled');
      this.nextButton.removeAttribute('disabled');
    }

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    if (this.enableSliderLooping) {
      this.addEventListener('slideChanged', event => {
        const currentPage = event.detail.currentPage;
        const previousPage = event.detail.previousPage;

        if (currentPage > previousPage) {
          const firstLiElement = this.slider.querySelector('li');
          this.slider.appendChild(firstLiElement);
        } else {
          const firstLiElement = this.slider.querySelector('li:first-child');
          const lastLiElement= this.slider.querySelector('li:last-child');
          this.slider.insertBefore(lastLiElement, firstLiElement);
        }
      });
    }
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;

    if (this.enableSliderLooping) {
      const clonedItems = Array.from(this.sliderItems).map(item => item.cloneNode(true));
      this.slider.append(...clonedItems, ...this.sliderItems);

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.slider.scrollLeft = this.sliderItemOffset * this.sliderItemsToShow;

      this.slider.scrollTo({
        left: this.slider.scrollLeft
      });
    }

    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          previousPage: previousPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }
      }));
    }

    if (this.enableSliderLooping) {

      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
        this.prevButton.setAttribute('data-scroll-loop', 'true');
      } else {
        this.prevButton.removeAttribute('data-scroll-loop');
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('data-scroll-loop', 'true');
      } else {
        this.nextButton.removeAttribute('data-scroll-loop');
      }

    } else {

      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);

    if(event.currentTarget.dataset.scrollLoop == 'true') {
      this.slideScrollPosition = event.currentTarget.name === 'next' ? 0 : this.sliderItemOffset * this.totalPages;
      this.slider.scrollTo({
        left: this.slideScrollPosition,
        behavior: "auto"
      });
      return;
    }

    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.storageKey = "selected_options";
    this.storage = localStorage.getItem(this.storageKey);
    this.onLoadSelectedOptions();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.addSelectedOptionsToStorage(this.options);

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
      this.toggleBisButton(false)
    } else {
      this.toggleBisButton(this.currentVariant.available);
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  onLoadSelectedOptions() {
    this.selectedOptions = this.getSelectedOptionsFromStorage();
    if (this.selectedOptions.length > 0) {
      this.options = this.selectedOptions;
      this.setSelectedOption();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
        this.toggleBisButton(false)
      } else {
        this.toggleBisButton(this.currentVariant.available);
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
      }
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    if (mediaGallery) {
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
    }

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        if (!document.querySelector('.product__info-container product-swatches')) {
          const variantSelectorsDestination = document.querySelector("[data-standard-variants-selectors]");
          const variantSelectorsSource = html.querySelector("[data-standard-variants-selectors]");
          if (variantSelectorsSource && variantSelectorsDestination) variantSelectorsDestination.innerHTML = variantSelectorsSource.innerHTML;
          new SizeChartSwitcher();
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      if(addButton.hasAttribute('data-preorder-button')) {
        addButtonText.textContent = window.variantStrings.preorder;
      } else { 
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    if (!modifyClass) return;
  }

  toggleBisButton(available) {
    const bisButton = document.querySelector('.klaviyo-bis-trigger')
    if(bisButton) {
      if (!available) {
        bisButton.classList.remove('hidden')
      } else {
        bisButton.classList.add('hidden')
      }
    }
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  getSelectedOptionsFromStorage() {
    let selectedOptions = [];
    if (typeof this.storage == 'string') {
      selectedOptions = JSON.parse(this.storage);
    }
    return selectedOptions;
  }

  addSelectedOptionsToStorage(newItem) {
    const stringifiedObj = JSON.stringify(newItem);
    if (stringifiedObj == "[object HTMLDivElement]" || stringifiedObj == null) return;
    localStorage.setItem(this.storageKey, JSON.stringify(newItem));
  }  
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
  
  setSelectedOption() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    fieldsets.forEach((fieldset, index) => {
      if (Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.value == this.options[index])) {
        Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.value == this.options[index]).setAttribute('checked', true);
        this.addSelectedOptionsToStorage(this.options);
      } else {
        Array.from(fieldset.querySelectorAll('input'))[0].setAttribute('checked', true);
        this.options[index] = Array.from(fieldset.querySelectorAll('input'))[0].value;
      }
    })
  }
}

customElements.define('variant-radios', VariantRadios);

Shopify.loadElements = function (data, selectors, parent = document) {
  Object.keys(selectors).forEach(key => {
    if (key[0] === '#') {
      data[key] = parent.getElementById(selectors[key].substring(1));
    }
    else if (key.slice(-1) === 's') {
      data[key] = parent.querySelectorAll(selectors[key]);
    }
    else {
      data[key] = parent.querySelector(selectors[key]);
    }
  });
};

Shopify.CountrySelector = function () {
  this.selectors = {
    countrySelectors: '[data-country-selector]',
    countrySelect: '.country-selector'
  };

  Shopify.loadElements(this, this.selectors);

  this.buildCountrySelectors()

};

Shopify.CountrySelector.prototype = {

  buildCountrySelectors: function () {
    const self = this;

    for (let i = 0; i < self.countrySelectors.length; i++) {
      let placeholder = self.countrySelectors[i];
      let selector = self.countrySelect.cloneNode(true);
      placeholder.appendChild(selector);
    }

  }

};

new Shopify.CountrySelector();

class SizeChartSwitcher {

  constructor() {
    if (!document.querySelector('.product-form__size-switcher')) {
      return;
    }
    this.initSwitchListeners();
  }

  initSwitchListeners() {
    let switchButtons = document.querySelectorAll('[data-switch-button]');
    for (let i = 0; i < switchButtons.length; i++) {
      let switchButton = switchButtons[i];
      switchButton.addEventListener('click', function (e) {
        let buttons = document.querySelectorAll('[data-switch-button]');
        for (let i = 0; i < buttons.length; i++) {
          buttons[i].classList.remove('active');
        }
        e.target.classList.add('active');

        let selectedChart = e.target.dataset.chartHandle;

        let sizeValues = document.querySelectorAll('.size-value');
        for (let i = 0; i < sizeValues.length; i++) {
          sizeValues[i].classList.remove('visible');
        }
        let sizeValuesToShow = document.querySelectorAll(`[data-${selectedChart}].size-value`);
        for (let i = 0; i < sizeValuesToShow.length; i++) {
          sizeValuesToShow[i].classList.add('visible');
        }
      });
    }
  }
};
new SizeChartSwitcher();


class ProductCardVariants extends HTMLElement {
  constructor() {
    super();

    this.productHandle = this.dataset.productHandle;
    this.variantsButtons = this.querySelectorAll('label');
    this.selectedLabel = null;
    this.submitButton = this.closest('.collection-card').querySelector('.card__information-button');
    this.cardElement = this.findParent('card-wrapper');
    this.errorContainer = this.querySelector('error-container')
    this.storageKey = 'selected_options';
    this.storage = localStorage.getItem(this.storageKey);

    if (this.cardElement.querySelector('.quick-add')) {
      this.cardElement.querySelector('.quick-add').addEventListener('click', this.toggleVariantsSelectors.bind(this));
    }

    this.variantsButtons.forEach((btn) => {
      if (btn.getAttribute('value') === '000') {
        this.selectedLabel = { target: btn };
        this.submitButton.style.color = '#fff';
        this.submitButton.style.backgroundColor = '#000';
        this.submitButton.style.pointerEvents = 'auto';
        if (btn.classList.contains('out-of-stock')) {
          this.submitButton.innerHTML = 'NOTIFY ME';
        } else {
          this.submitButton.innerHTML = 'ADD TO CART';
        }
      }

      btn.addEventListener('click', () => {
        if ('manualMode' in this.dataset) {
          this.selectedLabel = { target: btn };
          this.submitButton.style.color = '#fff';
          this.submitButton.style.backgroundColor = '#000';
          this.submitButton.style.pointerEvents = 'auto';
          if (btn.classList.contains('out-of-stock')) {
            this.submitButton.innerHTML = 'NOTIFY ME';
          } else {
            this.submitButton.innerHTML = 'ADD TO CART';
          }
        } else {
          this.processCard.bind(this);
        }
      });
    });

    this.submitButton.addEventListener('click', () => {
      this.processCard.bind(this)(this.selectedLabel);
    });
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }

  toggleVariantsSelectors(event) {
    const button = event.currentTarget;
    if (this.classList.contains("open")) {
      this.classList.remove("open");
      button.classList.remove("open");
    } else {
      this.classList.add("open");
      button.classList.add("open");
    }

    const slide = this.findParent("swiper-slide");
    const sliderWrapper = this.findParent("swiper-container");
    if (!slide || !sliderWrapper) return;

    const allSlides = sliderWrapper.querySelectorAll(".swiper-slide");
    const firstSlide = allSlides[0];
    const lastSlide = allSlides[allSlides.length - 1];
    if (slide === firstSlide || slide === lastSlide) return;

    const prevSlide = sliderWrapper.querySelector(".slider__arrow--prev");
    const nextSlide = sliderWrapper.querySelector(".slider__arrow--next");

    let arrow = nextSlide;
    if (slide.classList.contains("swiper-slide-active")) {
      arrow = prevSlide;
    }

    if (arrow.hasAttribute("disabled")) {
      arrow.removeAttribute("disabled");
    } else {
      arrow.setAttribute("disabled", true);
    }
  }

  findParent(className) {
    let parent = this.parentNode;
    while (parent) {
      if (parent.nodeType === 1 && parent.classList.contains(className)) {
        break;
      }
      parent = parent.parentNode;
    }

    return parent;
  }

  processCard(evt) {
    this.delay(100).then(() => {
      this.updateOptions();
      this.updateMasterId();
      if (evt.target.classList.contains('out-of-stock')) {
        globalThis.localStorage.setItem('bis', true);
        window.location.href = `/products/${this.productHandle}?variant=${this.currentVariant.id}`;
        return;
      }
      this.addToCart(evt);
      this.addSelectedOptionsToStorage(this.options);
    })
  }

  addToCart(evt, skipPreorder = false) {
    console.log('addToCart called');
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    
    if (!skipPreorder && evt.target.getAttribute('data-preorder-button') === 'true') {
      this.processPreorder(evt)
      return
    } else if (!skipPreorder) {
      this.checkIfPreordersinCart(evt)
      return 
    }

    console.log('preorder skipped');

    const formData = new FormData();
    formData.append('quantity', '1');
    formData.append('form_type', 'product');
    formData.append('id', this.currentVariant.id);

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    if (this.cart) {
      formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', '/?view=sections');
      this.cart.setActiveElement(document.activeElement);
    }

    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          // this.handleErrorMessage(response.description);
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }
        this.cart.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.submitButton?.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        // this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        globalThis.closeQuickAddModal();
      });
  }

  processPreorder(evt) {
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    fetch(`${routes.cart_url}.json`)
      .then((response) => response.json())
      .then((response) => {
        let allPreorders = response.items.every(i => i.title.toLowerCase().indexOf('pre-order') > -1);
        if (allPreorders) {
          this.addToCart(evt, true)
        } else {
          this.handleErrorMessage(window.cartStrings.preorderError)
        }
      })
  }

  checkIfPreordersinCart(evt) {
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    fetch(`${routes.cart_url}.json`)
      .then((response) => response.json())
      .then((response) => {
        let somePreorders = response.items.some(i => i.title.toLowerCase().indexOf('pre-order') > -1);
        if(somePreorders) {
          this.handleErrorMessage(window.cartStrings.instockError)
        } else {
          this.addToCart(evt, true)
        }
      })
  }

  delay(time) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, time);
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  getSelectedOptionsFromStorage() {
    let selectedOptions = [];
    if (typeof this.storage == 'string') {
      selectedOptions = JSON.parse(this.storage);
    }
    return selectedOptions;
  }

  addSelectedOptionsToStorage(newItem) {
    const stringifiedObj = JSON.stringify(newItem);
    if (stringifiedObj == "[object HTMLDivElement]" || stringifiedObj == null) return;
    localStorage.setItem(this.storageKey, JSON.stringify(newItem));
  }  

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      if (Array.from(fieldset.querySelectorAll('input')).length == 1) {
        return Array.from(fieldset.querySelectorAll('input'))[0].value;
      }
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  setSelectedOption() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    fieldsets.forEach((fieldset, index) => {
      if (Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.value == this.options[index])) {
        Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.value == this.options[index]).setAttribute('checked', true);
      } else {
        Array.from(fieldset.querySelectorAll('input'))[0].setAttribute('checked', true);
        this.options[index] = Array.from(fieldset.querySelectorAll('input'))[0].value;
      }
    })
    this.addSelectedOptionsToStorage(this.options);
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('product-card-variants', ProductCardVariants);

class ProductSwatches extends HTMLElement {
  constructor() {
    super();

    this.container = this.querySelector('.product-swatches__container');
    this.availableColorsContainer = this.querySelector('.product-grid-item__siblings-available');
    this.isProductPageSwatch = this.closest('.product__info-container');

    this.settings = this.setSettings();
    var hideIfEmpty = this.settings.hideIfEmpty;

    if (this.settings.groupTag) {
      const groupTAG = encodeURIComponent(this.settings.groupTag).replace('.', '-');
      this.fetchData(groupTAG)
        .then((responseJson) => {
          this.initSwatches(responseJson);
          this.setCurrent(this.settings.handle);
          this.hideIfEmpty(hideIfEmpty);
          if (!this.isProductPageSwatch) {
            this.bindEvents();
          }
        }).catch(err => {
          console.error(err)
        });

    } else {
      this.hideIfEmpty(hideIfEmpty);
      this.initSwatches([]);
    }
  }

  fetchData(groupTAG) {
    const sessionSwatchJson = sessionStorage.getItem(groupTAG);

    if (sessionSwatchJson != null) {
      console.log("%cFetched from session", "color:green");
      return new Promise((resolve) => {
        resolve(JSON.parse(sessionSwatchJson));
      });
    }

    console.log("%cFetched from URL", "color:green");
    return this.getDataFromShopifyUrl(groupTAG);
  }

  getDataFromShopifyUrl(groupTAG) {
    return new Promise((resolve, reject) => {
      fetch(`/collections/all/${groupTAG}?view=data`)
        .then((response) => {
          if (response.ok == false) {
            return [];
          }
          return response.json();
        }).then((responseJson) => {
          sessionStorage.setItem(groupTAG, JSON.stringify(responseJson));

          resolve(responseJson);
        }).catch(err => {
          console.error(err)
          reject(err)
        })
    });
  }

  bindEvents() {
    const parent = this.closest('[data-card-wrapper]');
    const swatches = this.querySelectorAll('[data-row-colour] a');
    const isQuickAdd = this.dataset.quickAdd == 'true';
    
    if (!swatches) return;

    var self = this;

    swatches.forEach((swatch) => {
      swatch.addEventListener('click', function (e) {
        e.preventDefault();
        
        fetchCardSlideData(swatch.dataset.handle, isQuickAdd)
          .then((cardSlide) => {
            if (self.settings.showVendor === false) {
              const elementToRemove = cardSlide.querySelector('.card__information .caption-with-letter-spacing');
              if (elementToRemove) {
                elementToRemove.remove();
              }
              parent.classList.add('no-vendor');
            }

            parent.innerHTML = cardSlide.innerHTML;

            const slider = parent.querySelector('.js-slider-collectionPage');
            let sliderConfig = {};

            if (isQuickAdd) {
              sliderConfig = {
                slidesPerView: 1.7,
                spaceBetween: 8,
                loop: false,
                freeMode: {
                  enabled: true,
                  sticky: true,
                  momentumRatio: 0.3
                },
              };
            } else {
              sliderConfig = {
                slidesPerView: 'auto',
                loop: true,
                freeMode: {
                  enabled: true,
                  sticky: true,
                  momentumRatio: 0.3
                },
                grabCursor: true,
                pagination: {
                  el: '.swiper-pagination',
                },
                navigation: {
                  nextEl: '.js-card-slider-arrow-next',
                  prevEl: '.js-card-slider-arrow-prev',
                },
              }
            }

            new Swiper(slider, {
              ...sliderConfig,
            });

            const swatchProdUrl = `/products/${swatch.dataset.handle}`;

            if (swatch.dataset.handle) {
              parent.querySelector('.quick-add-btn').addEventListener('click', () => {
                fetch(swatchProdUrl + '?view=quick-add')
                  .then(res => res.text())
                  .then(quickAddStr => {
                    const $quickAddModal = document.querySelector('.quick-add-modal');
                    $quickAddModal.querySelector('.quick-add-modal__inner').innerHTML = quickAddStr;
                    const $slider = $quickAddModal.querySelector('.js-slider-collectionPage');
                    new Swiper($slider, {
                      slidesPerView: 1.7,
                      spaceBetween: 8,
                      loop: false,
                      freeMode: {
                        enabled: true,
                        sticky: true,
                        momentumRatio: 0.3
                      },
                    });
                    $quickAddModal.classList.add('open');
                    document.documentElement.classList.add('overflow-hidden');
                  });
              });
            }
          });
      })
    })
  }


  hideIfEmpty(hideIfEmpty) {
    if (!hideIfEmpty) return;
    const availableSwatches = this.querySelectorAll('.product-swatches__container [data-available="true"]');
    if (availableSwatches.length == 0) {
      this.classList.add("swatch-empty--hide");
    };

  }

  setSettings() {
    const settingsRawJson = this.querySelector("[data-swatches-settings]");
    if (!settingsRawJson) return {}
    return JSON.parse(settingsRawJson.innerHTML);
  }

  initSwatches(products, maxIndex = 99) {
    var html = "";
    var optionsObject = {};

    if (!this.settings.swatchOptions) return;
      
    for (const option of this.settings.swatchOptions) {
      optionsObject[`${option}`] = [...new Set(products.map(p => p[`${option}`]))].filter(n => n)
    }

    let index = 0;

    for (const option in optionsObject) {
      html = html + `
        <legend class="form__label option--label">
          ${option.replace("_", " ")}: <b class="hidden">${this.settings[`${option}`]}</b>
          <span class="option--value" data-${option}-option></span>
        </legend>
        <div data-row-${option} class="product-swatches__container-row">`

      for (const optionValue of optionsObject[`${option}`]) {
        var potentialProducts = products.filter(p => p[`${option}`] == optionValue);

        if (!potentialProducts.length) continue;

        var product = potentialProducts[0];

        if (potentialProducts.length > 0) {
          for (const innerOption of this.settings.swatchOptions) {
            if (innerOption == option) continue;
            potentialProducts = potentialProducts.filter(p => p[`${innerOption}`] == this.settings[`${innerOption}`])
          }
          product = potentialProducts[0]
        }

        var firstAvailableVariant = null;

        if (!product) continue;

        for (const v of product.variants) {
          if (v.inventory_quantity > 0) {
            firstAvailableVariant = v;
            break;
          }
        }

        var img = this.getProductImage(product, option);

        const el = `<div class="pils-wrapper">
          <a data-available="${firstAvailableVariant ? "true" : "false"}" data-handle="${product.handle}" href="/products/${product.handle}">
          ${img}
          <span class="color-name">${product.colour}</span>
          </a>
        </div>`;

        if (index < maxIndex) {
          html += el;
        }

        index += 1;
      }

      
      const mobileMaxIdx = 3;
      const desktopMaxIdx = 5;

      if (index > mobileMaxIdx) {
        html += `<span class="mobile-more-swatches">+${index - 3}</span>`;
      }

      if (index > desktopMaxIdx) {
        html += `<span class="desktop-more-swatches">+${index - 5}</span>`;
      }

      html = html + "</div>"
    }

    if (this.availableColorsContainer) {
      const totalColours = [...new Set(products.map(prod => prod.colour))].length
      this.availableColorsContainer.innerHTML = `${totalColours} colour${totalColours > 1 ? 's' : ' '}`
    }

    if (html) {
      this.container.innerHTML = html;
      
      const $mobileMoreSwatchesBtn = this.container.querySelector('.mobile-more-swatches');

      if ($mobileMoreSwatchesBtn && this.container.dataset.productUrl) {
        $mobileMoreSwatchesBtn.addEventListener('click', () => {
          fetch(this.container.dataset.productUrl + '?view=quick-add')
            .then(res => res.text())
            .then(quickAddStr => {
              const $quickAddModal = document.querySelector('.quick-add-modal');
              $quickAddModal.querySelector('.quick-add-modal__inner').innerHTML = quickAddStr;
              const $slider = $quickAddModal.querySelector('.js-slider-collectionPage');
              new Swiper($slider, {
                slidesPerView: 1.7,
                spaceBetween: 8,
                loop: false,
                freeMode: {
                  enabled: true,
                  sticky: true,
                  momentumRatio: 0.3
                },
              });
              $quickAddModal.classList.add('open');
              document.documentElement.classList.add('overflow-hidden');
            })
        });
      }
    }
  }

  getProductImage(product, option) {
    var image = `<img src="${product.featured_image}" loading="lazy">`;
    if (option == "colour") {
      switch (this.settings.image_type) {
        case "metafield_image":
          const metafieldImage = product.swatch_image;
          if (metafieldImage) image = metafieldImage;
          break;
        case "metafield_colour":
          const metafieldColor = product.swatch_color;
          if (metafieldColor) image = `<span class="swatch" style="background-color:${metafieldColor}"></span>`;
          break;
        case "image_swatch":
          const colourTag = product.colour;
          if (colourTag) {
            const colour = colourTag.toLowerCase().replace(/ /g, "").replace(/ /g, "-").toLowerCase();
            image = `<span data-option-name="color" data-colour-${colour.toLowerCase()}> </span>`
          } else {
            image = ``
          }
          break;
        case "featured_image":
          const featuredImage = product.featured_image;
          if (featuredImage) image = `<img src="${featuredImage}" loading="lazy">`;
          break;
        case "first_variant_image":
          const firstVariantImage = product.variants[0].image;
          if (firstVariantImage) image = `<img src="${firstVariantImage}" loading="lazy">`;
          break;
        case "last_variant_image":
          const lastVariantImg = product.variants[product.variants.length - 1].image;
          if (lastVariantImg) image = `<img src="${lastVariantImg}" loading="lazy">`;
          break;
        default:
          break;
      }
    } else {
      return product[`${option}`]
    }
    return image;
  }

  setCurrent(handle) {
    var elements = this.container.querySelectorAll(`[data-handle="${handle}"]`)
    if (handle && elements.length) {
      elements.forEach(element => {
        element.classList.add("selected");
      })
    }
  }
}

document.addEventListener('DOMContentLoaded', (event) => {
  customElements.define('product-swatches', ProductSwatches);
});

Shopify.ImageWithDropdownAccordions = function () {
  this.selectors = {
    container: '.image-with-dropdowns',
    dropdown: '.dropdown',
    summary: '.drowpdown-summary'
  };

  this.breakpoint = window.matchMedia("(max-width: 990px)")

  this.expandFirstDropdown();
  this._addEventListeners();
}

Shopify.ImageWithDropdownAccordions.prototype = {
  expandFirstDropdown: function () {
    if (!this.breakpoint.matches) return;

    const containers = document.querySelectorAll(this.selectors.container);
    if (containers.length < 1) return;
    for (let container of containers) {
      const dropdowns = container.querySelectorAll(this.selectors.dropdown);
      if (dropdowns.length < 1) continue;

      dropdowns[0].setAttribute("open", "");
    }
  },
  _addEventListeners: function () {
    const containers = document.querySelectorAll(this.selectors.container);

    containers.forEach((container) => {
      const dropdowns = container.querySelectorAll(this.selectors.dropdown);

      dropdowns.forEach((dropdown) => {
        dropdown.addEventListener("click", function (e) {
          this._closeAllDropdowns(container);
        }.bind(this));
      });
    });
  },
  _closeAllDropdowns: function (container) {
    const dropdowns = container.querySelectorAll(this.selectors.dropdown);
    dropdowns.forEach((dropdown) => {
      dropdown.removeAttribute("open");
    });
  },
};

document.addEventListener("DOMContentLoaded", function () {
  new Shopify.ImageWithDropdownAccordions();
});

let pairContainer = document.querySelector('.js-pair-with-list--container');
let pairHeading = document.querySelector('.pair-with .heading');

if (pairContainer && pairHeading) {
  if (pairContainer.children.length == 0) {
    pairHeading.classList.add('heading--hide')
  }
}

setTimeout(() => {
  let cardVariants = document.querySelectorAll('product-card-variants');

  if (cardVariants) {
    cardVariants.forEach(element => {
      if (element.children[0].children.length == 0) {
        element.style.display = "none";
      }
    });
  }
}, 1200);


if(typeof pairWith != 'undefined' && pairWith.children.length > 0){
  document.querySelector('.pair-with-link--hide').classList.remove('pair-with-link--hide')
}
